import React, {useState,useRef} from 'react';
import NavBar from '../components/navbar';
import axios from 'axios';
import Footer from '../components/footer';
import bg from "../images/Try_it_out_background.png"
import "../styles/tryitout.css"
import { BsCaretDownFill, BsCaretUpFill  } from "react-icons/bs";
import { SyncLoader } from 'react-spinners';
import { disclaimerMssg, steps } from '../components/texts';
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';

const apikey_ID = process.env.REACT_APP_ACCESS_KEY_ID;
const apiKey = process.env.REACT_APP_ACCESS_KEY;



const Tryitout = () => {  

const [successfull,setSu] = useState('');
const [fileLoad,setFileLoad] = useState(false);
const [isChecked,setChecked] = useState(false);
const [color,setColor] = useState(''); // Default color

const handleCheckboxChange =()=>
{
  setChecked(!isChecked);
}
    const [formData, setFormData] = useState({
    name: '',
    email: '',
    file: null,

  });


const s3 = new S3Client({
  credentials: {
    accessKeyId: apikey_ID, // Replace with your AWS Access Key ID
    secretAccessKey: apiKey
 },
  region: 'ca-central-1'
})

/* This is optional */
const handlealert = () => {

  alert(disclaimerMssg);
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  

const[fileName,setFileName] = useState('');

  const hiddenFileInput = useRef(null);
  const handleSubmitFile = () => {
    hiddenFileInput.current.click();

  };
  const handleFileChange = (event) => {
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      setFileName(fileUploaded.name);
      setFormData((prevData) => ({
        ...prevData,
        file: fileUploaded, // Store file object
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
// Create an instance of react-aws-s3 Upload

      const uniqueNumber = Date.now()
      const newFileName = `${uniqueNumber}_test.txt`;
      const formDataToSend = new FormData();
        formDataToSend.append('username', formData.name);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('s3_file_path', newFileName);
      if (formData.file == null) {
        return;
      }

const params = {
  Bucket: 'joyfuel-backend',
  Key: newFileName,
  Body: formData.file,
  ContentType: formData.file.type
}
      const command = new PutObjectCommand(params);
      try{
        setFileLoad(true);
        console.log('Starting file upload2...');

        const putObj = await s3.send(command);
        console.log('File upload successful:', putObj);
        console.log(putObj);
        
      }
      catch(error) {console.error('Error uploading file:', error);}



      ///////////////////////////////

  let configAPI = {
        method: 'post',
        mode: 'cors',
        maxBodyLength: Infinity,
        url: '//api.laroye.ai/api/upload/',

        data : formDataToSend,
     
      };
      
      axios.request(configAPI)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        setFileLoad(false);
	setColor("black");
	setSu('File Uploaded');
      })
      .catch((error) => {
	setColor("red");
        console.log(error);
        setSu('File Upload Error');
        setFileLoad(false);
      });
      ///////////////////////////////////////


  


    };
    

  const [isCollapsed1, setIsCollapsed1] = useState(true);
  const [isCollapsed2, setIsCollapsed2] = useState(true);

  const toggleCollapse1 = () => {
    setIsCollapsed1(!isCollapsed1);
  };
  const toggleCollapse2 = () => {
    setIsCollapsed2(!isCollapsed2);
  };




  return (
<div style={{overflowX: 'hidden',overflowY: 'hidden', display:"flex", flexDirection:'column',justifyContent:'space-between'}}>
<NavBar/>
<div className="float-container" style={{backgroundImage:`url(${bg})`,  backgroundPosition: 'center',backgroundSize: '150%', height:'auto', backgroundRepeat: 'no-repeat', backgroundColor:"#435BF0"}}>


<div><h1 style={hd1}>**Analysis on X archive data available right now, more platforms coming soon**</h1></div>
<div className="float-child" >
      <div onClick={toggleCollapse1} style={{  padding: '15px',  border: 'Dashed black', margin:'0 4% 0 4%'}}><h1 style={hd1}>How to Request, Download, and View Your X Archive</h1>
      
      {!isCollapsed1 && steps}
          {isCollapsed1 && (<div  style={{display:'flex', justifyContent:'center', marginTop:'-8%'}} ><BsCaretDownFill style={{ fontSize: '3rem' }} onClick={toggleCollapse1}/></div>)} 
          {!isCollapsed1 && (<div  style={{display:'flex', justifyContent:'center'}} ><BsCaretUpFill style={{ fontSize: '3rem' }} onClick={toggleCollapse1}/></div>)} 
      </div>
    
</div>
<div className="float-child">
<div style={{ marginTop:"-21%",textAlign:'center', padding: '15px',  height: "80VH" }}><h1 style={{textAlign: 'center', fontFamily: 'Poppins',  color:"white"}}>File Upload</h1>

<form onSubmit={handleSubmit}>
            <input
              className='form'
              type="text"
              name="name"
              value={formData.name}
              placeholder='name'
              onChange={handleChange}
              required
            />
            <br/>
            {/* <input
            className='form'
              type="text"
              name="username"
              placeholder='username'
              value={formData.username}
              onChange={handleChange}
              required
            />
          <br/> */}

            <input
            className='form'
              type="email"
              name="email"
              value={formData.email}
              placeholder='email'
              onChange={handleChange}
              required
            />
          <br/>
    
            {/* <input
            className='form'
              type="password"
              name="password"
              placeholder='password'
              value={formData.password}
              onChange={handleChange}
              required
            />
          <br/> */} <br/>
    <div style={{color:"black", fontFamily:"Poppins"}}>              
    <input
          type="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
        /> I agree to the <span style={{fontWeight:"bold",color:"purple", cursor:"pointer"}} onClick={handlealert}>Privacy Disclaimer</span> and provide my consent for the analysis of my uploaded data by JoyFuel by Laroye AI.</div>
                  <br/>
    
          <button type="submit" onClick={handleSubmitFile}>Select File</button>
                      <input
              type="file"
              ref={hiddenFileInput}
              style = {{display:'none'}}
              onChange={handleFileChange}
              required
            />
            <div>{fileName}</div>
          <br/>
           <button style={{marginTop:"-10%",marginBlockEnd:"5%"}} type="submit" onClick={handleSubmit} disabled={!formData.name || !formData.email || !isChecked || !formData.file}>Submit{fileLoad?(<>ing<SyncLoader size={5} color="black" /> </>):''}</button> 
           
	<div style={{color:color, fontFamily:"poppins"}}>{successfull}</div>
	</form>



<div onClick={toggleCollapse2} className="float-child2" style={{marginBottom:'2%',height:'auto', marginTop:'4%', padding: '15px',  border: 'Dashed black'}}><h1 style={hd1}>How to Find the &quot;tweets.js&quot; File</h1>
        {!isCollapsed2 && (<p className="tio" style={hd2}><br/>Step 1<br/>
Extract the zipped X archive folder you downloaded through the link sent to your email by X
<br/><br/>Step 2<br/>
Click on the data folder, then select the &quot;tweets.js&quot; for upload</p>)}
{isCollapsed2 && (<div  style={{display:'flex', justifyContent:'center', marginTop:'-8%'}} ><BsCaretDownFill style={{ fontSize: '3rem' }} onClick={toggleCollapse2}/></div>)} 
{!isCollapsed2 && (<div  style={{display:'flex', justifyContent:'center'}} ><BsCaretUpFill style={{ fontSize: '3rem' }} onClick={toggleCollapse2}/></div>)} 
     
</div>
</div> 
</div>     
 
</div>
<div><Footer/></div>

</div>

  );
};

const hd1 = {    fontFamily: 'Poppins',
 margin:"1em", color:'white', textAlign:'center'}


const hd2 = {   
 
  fontFamily: 'Poppins',
  columnGap:'10px',
 color:'white', textAlign:'left', 
 marginBottom:'10%',
 justifyContent:'center',
 alignItems:'center'}

export default Tryitout;

